import { useState } from "react";

import ClipboardDocumentCheckIcon from "@heroicons/react/20/solid/ClipboardDocumentCheckIcon";
import ClipboardDocumentListIcon from "@heroicons/react/20/solid/ClipboardDocumentListIcon";
import router from "next/router";
import qs from "qs";

import { useGetCustomisation } from "queries/product-queries";

import adminStyles from "../AdminPanel.module.scss";

import styles from "./CopyLinkButton.module.scss";

export default function CopyLinkButton() {
  const [copied, setCopied] = useState(false);
  const { data: customisation } = useGetCustomisation();

  const handleCopy = () => {
    const url = new URL(window.location.origin + router.asPath);
    const query = new URLSearchParams(qs.stringify(customisation));
    url.search = query.toString();

    navigator.clipboard.writeText(url.toString());
    setCopied(true);
    setTimeout(function () {
      setCopied(false);
    }, 2000);
  };

  return (
    <button
      className={[adminStyles.tool, adminStyles.halfTool].join(" ")}
      onClick={() => handleCopy()}
    >
      <div className={styles.mainRow}>
        {copied ? (
          <ClipboardDocumentCheckIcon className={styles.copiedIcon} />
        ) : (
          <ClipboardDocumentListIcon className={styles.notCopiedIcon} />
        )}
        <div>
          <p className={adminStyles.toolTitle}>
            {copied ? "Copied!" : "Copy link to current page"}
          </p>
        </div>
      </div>
    </button>
  );
}
